import React, { useEffect, useState } from "react";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../../constants/Contract";
import {
  isBrokerAndCorpContract,
  isBrokerORMOC,
  isCareerContract,
} from "../../../../common/Functions";

const ConfAppContractDetails = ({
  contract_details,
  contracttypedesc,
  hasFinancingAddon,
}) => {
  const [contractDetails, setContractDetails] = useState({});

  useEffect(() => {
    if (contract_details) {
      setContractDetails(contract_details);
    }
  }, [contract_details]);

  const renderContractDetailRow = (label, value) => (
    <div className="row">
      <div className="col-lg-3 col-md-6 col-sm-12">
        <strong>{label}&nbsp;</strong>
      </div>
      <div className="col-lg-9 col-md-6 col-sm-12 data">{value || "-"}</div>
    </div>
  );

  return (
    <div id="confidential-contract">
      <div className="mm-spacing">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-12">
            <h3 id="conf_personal_info">Contract Details</h3>
          </div>
        </div>

        {contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.MMLIS &&
          contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS && (
            <>
              {renderContractDetailRow(
                "Contract Effective Date*",
                contractDetails.effectivedate
              )}
              {renderContractDetailRow(
                isBrokerORMOC(contracttypedesc)
                  ? "Brokerage Director Name*"
                  : "Sales Manager Name*",
                contractDetails.brokeragedirectorname
              )}
              {renderContractDetailRow(
                isBrokerORMOC(contracttypedesc)
                  ? "Brokerage Unit Number*"
                  : "Sales Unit Number*",
                contractDetails.brokerageunitnumber
              )}
              {!isCareerContract(contracttypedesc) &&
                contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.MMLIS &&
                contracttypedesc !==
                  CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS &&
                contracttypedesc !==
                  CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER &&
                renderContractDetailRow(
                  "Comments from Agency",
                  contractDetails.comment
                )}
              {isBrokerAndCorpContract(contracttypedesc) &&
                renderContractDetailRow(
                  "Comments from Agency",
                  contractDetails.comment
                )}
            </>
          )}
        {contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS && (
          <>
            {renderContractDetailRow(
              "Contract Effective Date*",
              contractDetails.effectivedate
            )}
          </>
        )}
      </div>
      {(isCareerContract(contracttypedesc) ||
        contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.MMLIS ||
        contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS ||
        contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER) && (
        <>
          <div className="mm-section mm-spacing">
            MASSMUTUAL BUSINESS ADDRESS
          </div>
          {renderContractDetailRow(
            "Street Address*",
            contractDetails.mmbusinessaddress1
          )}
          {renderContractDetailRow(
            "Apartment, Suite, Building, Gate Code",
            contractDetails.mmbusinessaddress2
          )}
          {renderContractDetailRow("City*", contractDetails.mmbusinesscity)}
          {renderContractDetailRow(
            "State/Province*",
            contractDetails.mmbusinessstate
          )}
          {renderContractDetailRow(
            "ZIP Code*",
            contractDetails.mmbusinesszipcode
          )}
          {contractDetails.mmbusinessstate === "PR" &&
            renderContractDetailRow(
              "Urbanization",
              contractDetails.mmbusinessurbanization
            )}
          {(contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS ||
            contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER) &&
            renderContractDetailRow(
              "Business Phone Number",
              contractDetails.mmbusinessphonenumber
            )}
          {contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS &&
            contracttypedesc !== CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER &&
            renderContractDetailRow(
              "Business Phone Number*",
              contractDetails.mmbusinessphonenumber
            )}

          {!hasFinancingAddon && (
            <>
              <hr />
              {renderContractDetailRow(
                "Comments from Agency",
                contractDetails.comment
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ConfAppContractDetails;
